import React, {useState, useEffect} from 'react';
import Video from './img/video1.mov';
import SharecareMobil from './img/SharecareMobil.png';
import logo_sharecare1 from './img/logo_sharecare1.png';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import './style.css';
import logo from './img/logo.png';
import fondo from './img/fondo3.png';
import { BuscadorHome } from './BuscadorHome';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';

export const BannerMarket = (props) => {
	const {MenuLateralAux, chageMenuLateralAux, setShowToast} = props;
	const {
		Empresas,
		setEmpresas,
		mapa,
		setMapa,
		setModalUbiacion,
		setEmpresasCargadas,
		getEmpresas_preRegistradas,
		limite,
		setBuscarNombre,
		setBuscarCategoria,
		setBuscarLocalidad,
		setBuscarProvincia,
	} = props;
	const [TipoBanner, setTipoBanner] = useState(true);

	const [ModalBanner, setModalBanner] = useState(false);

	useEffect(() => {
		if (document.getElementById('root').clientWidth <= 600) {
			setTipoBanner(false);
		} else {
			setTipoBanner(true);
		}
		window.addEventListener('resize', () => {
			if (document.getElementById('root').clientWidth <= 600) {
				setTipoBanner(false);
			} else {
				setTipoBanner(true);
			}
		});
	}, []);

	return (
		<>
			<MenuLateralAB
					seleccionado={16}
					MenuLateralAux={MenuLateralAux}
					chageMenuLateralAux={chageMenuLateralAux}
				/>
			<div id='buscador' className='centBannerMain'>
				<div className="container h-100">
					<div className='row justify-content-start h-100'>
						<div className='text-start col-lg-12 align-items-end row justify-content-start'>
								<h1 className="fs-2 col-lg-9 text-white fw-semibold lh-sm mb-4" style={{ fontStyle: 'italic', letterSpacing: '-0.5px' }}>
									Ayuda profesional cuando de verdad la necesitas. Cuidados verificados y de confianza, a domicilio o en consulta, con reserva inmediata, horarios flexibles y seguimiento claro.

								</h1>
								<p className='fs-5 col-lg-9 text-white'>Cuidados que llegan cuando los necesitas

</p>
								{/* <div className='flex flex-nowrap justify-content-between'> 
									<div>
										<img src={eslogan} alt="Lo que quieras, donde quieras, cuando quieras." />
									</div>
									<div>
										<img src={fondo} alt="Imagen de fondo" />
									</div>
								</div> */}
						</div>
						{ <div className='col-lg-9'>
							<BuscadorHome
								Empresas={Empresas}
								setEmpresas={setEmpresas}
								mapa={mapa}
								setMapa={setMapa}
								setModalUbiacion={setModalUbiacion}
								setEmpresasCargadas={setEmpresasCargadas}
								getEmpresas_preRegistradas={getEmpresas_preRegistradas}
								setBuscarNombre={setBuscarNombre}
								setBuscarCategoria={setBuscarCategoria}
								setBuscarLocalidad={setBuscarLocalidad}
								setBuscarProvincia={setBuscarProvincia}
								limite={limite}
								/>
						</div> }
						{/* <div className='w-50'>
							<img className="img-banner" src={fondo} alt='banner'/>
						</div> */}
					</div>
				</div>
				
				
			</div>
			{/* <div id='buscador' className="hero centBannerMain">
				<div className="container">
					<div className="row align-items-center flex flex-wrap">
						<div class="col-lg-6 z-10">
							<h1 class="display-4 fw-bold mb-3">
								<img src={eslogan} alt="" />
							</h1>
							<BuscadorHome
								Empresas={Empresas}
								setEmpresas={setEmpresas}
								mapa={mapa}
								setMapa={setMapa}
								setModalUbiacion={setModalUbiacion}
								setEmpresasCargadas={setEmpresasCargadas}
								getEmpresas_preRegistradas={getEmpresas_preRegistradas}
								setBuscarNombre={setBuscarNombre}
								setBuscarCategoria={setBuscarCategoria}
								setBuscarLocalidad={setBuscarLocalidad}
								setBuscarProvincia={setBuscarProvincia}
								limite={limite}
								/>
						</div>
						<div class="col-lg-6">
							<img className="img-banner" src={fondo} alt="Fondo"/>
						</div>
					</div>
				</div>
			</div> */}
			{/* <section id='buscador' class="centBannerMain flex place-items-center vh-60 text-center text-white">
				<div class="container flex-grow flex align-items-center justify-content-center">
					<div class="content buscador-effect p-2 text-md-start rounded-3">
						<div className='text-start d-flex'>
							<h1 className='p-2 fs-1 text-uppercase fw-bolder'>Lo que <span className='text-dark'>quieras,</span>
								<br /> donde <span className='text-dark'>quieras,</span>
								<br /> cuando <span className='text-dark'>quieras.</span>
							</h1>
						</div>
						<BuscadorHome
							Empresas={Empresas}
							setEmpresas={setEmpresas}
							mapa={mapa}
							setMapa={setMapa}
							setModalUbiacion={setModalUbiacion}
							setEmpresasCargadas={setEmpresasCargadas}
							getEmpresas_preRegistradas={getEmpresas_preRegistradas}
							setBuscarNombre={setBuscarNombre}
							setBuscarCategoria={setBuscarCategoria}
							setBuscarLocalidad={setBuscarLocalidad}
							setBuscarProvincia={setBuscarProvincia}
							limite={limite}
							/>
					</div>
				</div>
			</section> */}
		</>
	);
};
